import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getExchangeUrl } from '@/utils/location';
import { HeaderItem } from '.';

export const useDownloadApp = () => {
  const { t } = useTranslation();

  return useMemo<HeaderItem[]>(
    () => [
      {
        title: t('btn.download'),
        url: getExchangeUrl().downloadApp,
      },
    ],
    [t],
  );
};
